(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/vikinglotto/assets/javascripts/prescript.js') >= 0) return;  svs.modules.push('/modules/vikinglotto/assets/javascripts/prescript.js');

'use strict';

svs.vikinglotto = svs.vikinglotto || {};
svs.vikinglotto.views = svs.vikinglotto.views || {};
svs.vikinglotto.components = svs.vikinglotto.components || {};
svs.vikinglotto.logger = new svs.core.log.Logger('module:vikinglotto');


 })(window);